module.exports = __webpack_public_path__ + "img/medical-tests-x.eef3d669.svg";